//ClienteDataNascimento
import React, { useEffect, useRef, useState } from "react";
import { SecurityPageProps } from "models/security";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";

import { addDataNascUnlockCartao } from "redux/features/cartao/desbloqueio-slice";
import ContainerFlex from "components/ContainerFlex";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";

import * as St from "./styles";
import { RouteNames } from "routes/routes";
import { showMessage } from "utils/messages";
import moment from "moment";
import { dateMask } from "utils/mask";

const ClienteDataNascimento: React.FC<SecurityPageProps> = ({
  title,
  subDescription,
  description,
  nextStep,
  backStep,
}) => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (input.length <= 8) {
      setValue(dateMask(input).masked);
    }
  }, [input]);

  const {
    cartao: { validarCartao },
  } = useAppSelector((state) => state.cartaoDesbloqueio);

  const handleSubmit = async () => {
    dispatch(addDataNascUnlockCartao(value));
    if (moment(validarCartao?.dataNascimento).format("DD/MM/YYYY") === value) {
      const destino = nextStep || RouteNames.UNLOCK_CLIENTE_CRIAR_SENHA;

      const stepAposDestino: Record<string, string> = {
        [RouteNames.UNLOCK_CLIENTE_CRIAR_SENHA]: RouteNames.UNLOCK_CLIENTE_CONFIRMAR_SENHA,
        [RouteNames.SECURITY_SENHA_DESBLOQUEIO_USUARIO_ATIVO]: RouteNames.UNLOCK_CLIENTE_PUSH_SMS,
      };

      const propsRouter: SecurityPageProps = {
        nextStep:
          stepAposDestino[destino] || RouteNames.UNLOCK_CLIENTE_CONFIRMAR_SENHA,
        backStep: RouteNames.HOME,
        fluxoUnlock: true,
      };

      history.push({
        pathname: destino,
        state: { ...propsRouter },
      });
    } else {
      showMessage(
        "warning",
        "Desbloqueio de Cartão!",
        "Data de nascimento informada diferente do cadastrado para este cartão. Verifique!",
        { timer: 3700, showConfirmButton: false }
      );
    }
  };

  const clickToBack = () => {
    history.push(backStep);
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Desbloqueio</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Por favor, digite a tua <span>Data de Nascimento</span> e pressione
            <br />a tecla verde (ENTRA), para continuar a operação:
          </span>
        </St.Description>
      </ContainerFlex>
      <ContainerFlex center>
        <ContainerFlex width={60}>
          <ContainerFlex marginBottom={10}>
            <Input
              label="Valor"
              style={{
                height: "15%",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
              name="valorInfo"
              value={value}
              onChange={(e) => setValue(e)}
              edit
              disabled
            />
          </ContainerFlex>
          <KeyboardWrapper
            onPressBack={clickToBack}
            keyboardRef={keyboard}
            onChange={setInput}
            typeKeyboard="numeric"
            onPressEnter={() => handleSubmit()}
          />
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClienteDataNascimento;
